/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class QPChatCandidateColumnEntity extends Entity {
  createdAt: string | null = null;
  disabledColumns: string[] = [];
  enabledColumns: string[] = [];
  id: string = '';
  updatedAt: string | null = null;
  userId: string = '';
  static override key = 'QPChatCandidateColumn';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'QPChatCandidateColumn' in input
    ) {
      const { QPChatCandidateColumn: wrapped, ...rest } = input as {
        QPChatCandidateColumn: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}